// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__30Tl5","backdrop":"Modal_backdrop__kFt5Y","outer":"Modal_outer__1bYea","inner":"Modal_inner__2TafC","close":"Modal_close__1Pc3U","icon":"Modal_icon__VFbzD"};